<template>
  <div class="commonInfo page">
    <!-- 头部 -->
    <div class="common-header">
      <div class="header-top">
        <i
          @click="back()"
          class="iconfont iconzuojiantou"
          style="color: #fff; font-size: 20px"
        ></i>
        <span v-if="active == '0'">{{type === 2 ? '开通电子账户' : '上传身份信息'}}</span>
        <span v-if="active == '1'">身份信息确认</span>
        <span v-if="active == '2'">绑定银行卡</span>
        <span v-if="active == '3'">完成</span>
      </div>
      <!-- 步骤条 -->
      <Steps :active="active" />
    </div>
    <!-- 上传身份证正反面组件 -->
    <upload-card v-show="active == '0'" v-on:onNextStep="next"></upload-card>

    <!-- 身份证信息确认-->
    <base-info v-show="active == '1'" :authInfoVo="authInfoVo"  v-on:onNextStep="next"></base-info>

    <!-- 绑定银行卡 -->
     <bind-card v-show="active == '2'" :type="type" :authInfoVo="authInfoVo" v-on:onNextStep="next"></bind-card>

    <!-- 认证成功组件 -->
    <identity-finish v-show="active == '3' && type == 1"></identity-finish>
    <!-- 银行卡添加成功组件 -->
    <identity-finish v-show="active == '3' && type == 2"></identity-finish>
    <!--    <open-card v-show="active == '3' && type == 2" :authInfoVo="authInfoVo" v-on:onNextStep="next"></open-card>  取消二类户开通入口-->
  </div>
</template>

<script>
// 引入身份信息确认组件
import BaseInfo from "./components/baseInfo";
import uploadCard from "./components/uploadCard";
import IdentityFinish from "./components/identityFinish";
import OpenCard from "./components/openCard.vue";
import Steps from "./components/steps.vue";
import BindCard from "./components/bindCard.vue";
import config from "../../utils/config";
import http from "../../api/index.js";
import {Toast} from "vant"
export default {
  data() {
    return {
      active: 0,
      // type: 2,   // 取消二类户开通入口
      type: 1,
      authInfoVo: {
        userName: '',
        idNo: '',
        bankAccount: "",
        bankShort: "",
        idCardEndTime: '',
        idCardBeginTime: '',
        // 最终要提交的信息
      },
    };
  },
  components: {
    uploadCard,
    IdentityFinish,
    OpenCard,
    BaseInfo,
    Steps,
    BindCard,
  },
  mounted() {
    //http://192.168.0.100:8080/commonInfo?type=2&from=12
    // type二类账户: 2  实名认证: 1
    const url = new URL(location.href);
    // const type = url.searchParams.get('type') || 2;  // 取消二类户开通入口
    let type = url.searchParams.get('type') || 1;
    // 取消二类户开通入口
    if (type == 2) {
        type = 1;
    }

    this.type = type;
    console.log("this.type", this.type);
  },
  methods: {
    // 返回上一层
    back() {
      if (this.active === 0) {
        this.$router.go(-1);
      } else {
        this.active--;
      }
    },
    // 步骤条
    next(value, data) {
    Object.assign(this.authInfoVo, data);
     if (value === 1) { // 收集第一步身份证信息
      this.active++;
     }
     if (value === 2) { // 收集第二步 资料信息
      let apiUrl = config.accBasicAuthInfo; // 开通电子账户保留个人信息
      if (this.type == 1) {
       apiUrl = config.basicAuthInfo; // 实名认证保存基本信息
      }
      // this.$toast.loading('提交中...')
      const toast = Toast.loading({
         duration: 0, // 持续展示 toast
         forbidClick: true,
         message: "提交中..."
     });
      http.post(apiUrl, this.authInfoVo).then(({code, data, message }) => {
       if (code === 0) {
         if(data.code===200){
           this.active++;
           toast.clear()
         }else{
           this.$toast.fail(data.message)
           toast.clear()
         }
       } else {
        this.$toast.fail(message)
        toast.clear()
       }
      });
     }
     if(value === 3) {
      this.active++
     }
    },
  },
};
</script>

<style lang="less" scoped>
.van-cell::after {
  border-bottom: none;
}
.van-steps {
  height: 100px;
  line-height: 100px;
  background: linear-gradient(117deg, #0681fd 0%, #0178f2 100%);
}
.van-step--finish {
  color: #ffffff;
}
.van-step--horizontal:first-child .van-step__title {
  margin-top: 20px;
}
.commonInfo {
  width: 750px;
  height: auto;
  .common-header {
    position: relative;
    height: 285px;
    padding-top: 20px;
    box-sizing: border-box;
    //   渐变色
    background: linear-gradient(117deg, #0681fd 0%, #0178f2 100%);
    .iconzuojiantou {
      position: absolute;
      left: 30px;
    }
    span {
      font-size: 32px;
      color: #fff;
    }
  }
}
.next {
  width: 100%;
  height: 90px;
  background: #0681fd;
  line-height: 90px;
  text-align: center;
  color: #fff;
  font-size: 18px;
}
.common-footer {
  width: 100%;
  height: 1.2rem;
  background: #0681fd;
  line-height: 1.2rem;
  text-align: center;
  color: #fff;
  font-size: 0.453333rem;
  position: fixed;
  bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/commonInfo/index.vue